/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function nn(n,r,t){return n?r(n):t?.(n)}export{nn as when};
//# sourceMappingURL=when.js.map
